import axiosInstance from "../config/axiosInstance";

export const getUsersIn = async () => {

      const data = await axiosInstance.get(`/api/admin/get/allusers`);
      return data;
  

};

export const getAllPlansIn = async () =>  {

    const data = await axiosInstance.get(`/api/admin/get/allplans`);
    return data;

};